Ext.define('SA.model.ComboLocation', {
    extend: 'SA.model.CustomLocation',

    constructor({constituents}) {
        this.callParent(arguments);

        this.constituents = constituents;
    },

    getConstituentIds() {
        return this.constituents.map(constituent => constituent.getId());
    },

    getGeoUnitId() {
        return this.constituents[0].getGeoUnitId();
    },

    hasCensusReleaseYear(censusReleaseYear) {
        return this.constituents.every(constituent => constituent.hasCensusReleaseYear(censusReleaseYear));
    }
});